import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { FuelcardService } from '../vdms_core/services/api/fuelcard.service';
import { DateExpirePipe } from '../vdms_shared/pipes/date-expire.pipe';
import { ExcelFileDownloadServices } from '../vdms_shared/utils/excelDownload.services';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-fuel-card-details',
  templateUrl: './fuel-card-details.component.html',
  styleUrls: ['./fuel-card-details.component.css']
})
export class FuelCardDetailsComponent implements OnInit {

  activeCardData: any = [];
  blockedCardData: any = [];
  unassignCardData: any = [];
  receivedAllFuelCardRecord: any = [];
  public isDropdownOpen = false;
  private clickListener: () => void;
  @ViewChild('dropdownContainer') dropdownContainer!: ElementRef;
  constructor(
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private fuelCardService: FuelcardService,
    private dateExpirePipe: DateExpirePipe,
    private excelFileDownloadServices: ExcelFileDownloadServices,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.getAllFuelCard()
  }

  async getAllFuelCard() {
    const limit = 100;  // Set the limit for records per request
    let offset: number = 0;
    this.receivedAllFuelCardRecord = [];
    this.spinnerService.show();

    try {
      const data = await this.fuelCardService.getAllFuelCardMaster(offset, limit);
      console.log("Fetched Page Data:", data);

      // Convert all card_number values to string
      const normalizedData = data.map((item: any) => ({
        ...item,
        card_number: String(item.card_number)
      }));

      this.receivedAllFuelCardRecord = [
        ...this.receivedAllFuelCardRecord,
        ...normalizedData
      ];

      console.log(
        "All records fetched:",
        typeof this.receivedAllFuelCardRecord,
        this.receivedAllFuelCardRecord
      );

      this.splitRecordsByStatus();

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.spinnerService.hide();
    }
  }

  splitRecordsByStatus() {
    if (!Array.isArray(this.receivedAllFuelCardRecord)) {
      console.warn('[FuelCardDetailsComponent] splitRecordsByStatus received non-array');
      return;
    }

    var statusSet = new Set<string>();
    for (var i = 0; i < this.receivedAllFuelCardRecord.length; i++) {
      var r = this.receivedAllFuelCardRecord[i];
      if (r && r.status) {
        statusSet.add(String(r.status));
      }
    }
    console.log('[FuelCardDetailsComponent] Discovered statuses:', Array.from(statusSet));

    var splitRecords: { [k: string]: any[] } = {};
    statusSet.forEach(function (s) { splitRecords[s] = []; });

    for (var j = 0; j < this.receivedAllFuelCardRecord.length; j++) {
      var card = this.receivedAllFuelCardRecord[j];
      if (card && card.status && splitRecords[card.status]) {
        splitRecords[card.status].push(card);
      }
    }

    this.activeCardData = splitRecords['ASSIGN'] || splitRecords['ACTIVE'] || [];
    this.unassignCardData = splitRecords['UNASSIGN'] || splitRecords['UNASSIGNED'] || [];
    this.blockedCardData = splitRecords['INACTIVE'] || splitRecords['BLOCKED'] || [];

    console.log('[FuelCardDetailsComponent] activeCardData:', this.activeCardData.length,
      'unassignCardData:', this.unassignCardData.length,
      'blockedCardData:', this.blockedCardData.length);

    if (!this.activeCardData.length &&
      !this.unassignCardData.length &&
      !this.blockedCardData.length) {
      console.warn('[FuelCardDetailsComponent] All category arrays empty – check status values / mapping.');
    }
  }
  public async downloadExcel(status: any) {
    let dataSheet: any[] = [];
    let download: any[];
    this.toggleDropdown();
    switch (status) {
      case 'ASSIGN':
        download = this.activeCardData;
        break;
      case 'UNASSIGN':
        download = this.unassignCardData
        break;
      case 'INACTIVE':
        download = this.blockedCardData
        break;
      default:
        download = this.receivedAllFuelCardRecord
        break;
    }

    for (const sheet of download) {
      const cardStatus = this.dateExpirePipe.transform(sheet.card_expiry_date);

      const dataRecord = {
        "Card Number": sheet.card_number,
        "Card Provider": sheet.card_provider,
        "Card Expiry Date": sheet.card_expiry_date,
        "Card Expiry Status": cardStatus.status,
        "Status": sheet.status
      };


      dataSheet.push(dataRecord);
    }

    this.excelFileDownloadServices.downloadExcel(dataSheet);
  }

  // Toggle the dropdown on button click
  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;

    if (this.isDropdownOpen) {
      this.addClickOutsideListener();
    } else {
      this.removeClickOutsideListener();
    }
  }

  // Open the dropdown on hover
  openDropdown(): void {
    this.isDropdownOpen = true;
  }

  // Close the dropdown when the mouse leaves the container
  closeDropdown(): void {
    this.isDropdownOpen = false;
  }

  // Add a listener for clicks outside the dropdown
  private addClickOutsideListener(): void {
    this.clickListener = this.renderer.listen('document', 'click', (event: MouseEvent) => {
      if (this.dropdownContainer && !this.dropdownContainer.nativeElement.contains(event.target)) {
        this.isDropdownOpen = false;
        this.removeClickOutsideListener();
      }
    });
  }

  // Remove the outside click listener to prevent memory leaks
  private removeClickOutsideListener(): void {
    if (this.clickListener) {
      this.clickListener();
      this.clickListener = undefined;
    }
  }

  navigateToNewFuelCard() {
    this.router.navigate(['pages/add-fuel-card-details']);
  }



  file: File;
  statusList = [];
  vendorList = [];
  uploadList = [];
  uploadStatus: number = 0;
  progresspercent: number = 0;
  displayValue: number = 0;
  arrayBuffer: any;
  sheetlength: number = 0;
  cnt: number = 1;
  enableUploadBtn: boolean = false;
  @ViewChild('uploadFile') uploadFile: ElementRef;
  @ViewChild('closeUploadModalBtn') closeuploadModalBtn: ElementRef;

  incomingfile(event) {
    this.uploadStatus = -1;
    this.file = event.target.files[0];
    this.enableUploadBtn = false;
    setTimeout(() => {
      this.enableUploadBtn = true;
    }, 100);
  }

  isInvalid(str) {
    if (str == 'undefined' || str == null || str.length < 1)
      return true;
    else
      return false;
  }

  uploadFuelCard() {
    if (this.file == undefined) {
      return;
    }

    this.statusList = [];
    this.uploadList = [];
    this.progresspercent = 0;
    this.uploadStatus = 1;
    this.displayValue = 0;

    let fileReader = new FileReader();
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var worksheet = workbook.Sheets["data"];
      var sheet = XLSX.utils.sheet_to_json(worksheet, { raw: true })
      this.sheetlength = sheet.length;
      this.startProcess(sheet);
    }
    fileReader.readAsArrayBuffer(this.file);
    this.uploadStatus = 1;
  }

  //After reading insert the record 
  async startProcess(sheet) {
    for (const dict of sheet) {

      var s_no = String(dict["S.No"]).trim();
      var card_number = String(dict["New Card No"]).trim();
      var card_provider = String(dict["Card Provider"]).trim();

      const excelDateToJSDate = (serial) => {
        // Excel's base date is 1900-01-01, so we adjust it by subtracting 25569 (Excel to Unix date shift)
        const jsDate = new Date((serial - 25569) * 86400 * 1000); // Convert to JavaScript Date

        // Format the date as yyyy-mm-dd
        const formattedDate = jsDate.toISOString().split('T')[0];

        return formattedDate;
      }

      const rcdate = excelDateToJSDate(dict['Card Expiry Date']);
      var card_expiry_date = rcdate;


      var carData = {
        card_number: card_number,
        card_provider: card_provider,
        card_expiry_date: card_expiry_date
      }

      console.log(carData);


      var errorText = ""

      if (this.isInvalid(carData.card_number)) {
        errorText = errorText + 'Invalid Card Number :: '
      }
      if (this.isInvalid(carData.card_provider)) {
        errorText = errorText + 'Invalid Card Provider :: '
      }


      if (carData.card_expiry_date) {
        var dateSplitArr = carData.card_expiry_date.split('-');
        if (dateSplitArr.length != 3 || dateSplitArr[0].length != 4 || dateSplitArr[1].length != 2 || dateSplitArr[2].length != 2) {
          errorText = errorText + 'Invalid Card Expiry Date :: '
        }
      }


      if (errorText.length > 0) {
        // console.log("----------" + errorText)
        this.statusList.push({ line_no: s_no, status: 'Error', error: errorText });
        this.displayValue = 1;
        this.uploadStatus = 3;
      } else {
        this.uploadList.push(carData)
        this.progressIncrement();
      }

    }

    if (this.statusList.length == 0 && this.uploadList.length > 0) {
      // console.log('inside if');
      for (var i = 0; i < this.uploadList.length; i++) {
        var item = this.uploadList[i];
        this.OnSaveFuelcard(item, i);
      }
    }
  }

  closeModal() {
    this.closeuploadModalBtn.nativeElement.click();
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  async OnSaveFuelcard(value, i) {
    await this.fuelCardService.createFuelMasterCard(value);
    if (i == this.uploadList.length - 1) {
      this.closeModal();
    }
  }

  progressIncrement() {
    if (this.cnt == this.sheetlength) {
      this.uploadStatus = 2;
    }

    this.progresspercent = this.cnt * 50 / this.sheetlength;
    this.cnt++;
  }

  resetFile() {
    this.uploadFile.nativeElement.value = null;
    this.file = undefined;
    this.enableUploadBtn = false;
    this.uploadStatus = 0;
  }

  navigateToAssignFuelCard() {
    this.router.navigate(['pages/assign-fuel-card']);
  }
  
}
